// extracted by mini-css-extract-plugin
module.exports = {"Label":"Label_Label__29Z00","Label__Text":"Label_Label__Text__9HIeH"};